module.exports = __webpack_public_path__ + "static/media/Impressum01.29b08f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Impressum01.jpg
// module id = 402
// module chunks = 0